import LocalCurrencyFilterSelector from './LocalCurrencyFilterSelector';

export default LocalCurrencyFilterSelector;